module.exports = __webpack_public_path__ + "static/checkout_hero_background-8425589bf0ea3c2fe086b90d3b5543df.png";